module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point3_3-c13e21587d3b31620845055b7d5c169f.jpg";